<script>
    import TopMenu from '../components/TopMenu.svelte';
    import Header from '../components/Header.svelte';
    import Loading from '../components/Loading.svelte';
    import {api, store} from '../stores.js';
    
    const user = store('credentials', 'appUserAuth');

    const fetchProductList = (async () => {
        let result = await api('getProductList', {login: $user.email, password: $user.pasport});
        return result.data ? result.data : [];
    })();
</script>

<TopMenu title="Список продуктов" />

<div id="appCapsule">
    <Header title="Список продуктов" />
    
    {#await fetchProductList}
        <Loading />
    {:then data}
        <ul class="listview image-listview">
            {#each data as {naimenovanie, idRegPred}}
                <li>
                    <div class="item">
                        <div class="in">
                            <div>{naimenovanie}</div>
    
                            {#if idRegPred > 0}
                                <span class="badge badge-success"><ion-icon name="lock-open-outline"></ion-icon></span>
                            {:else}
                                <span class="badge badge-danger"><ion-icon name="lock-closed-outline"></ion-icon></span>
                            {/if}
                        </div>
                    </div>
                </li>
            {/each}
        </ul>
    {/await}
</div>
